import { RESIDE_DOMAIN } from "./whitelistDomainValidator";
/**
 * Validates that the reside domain is not included in a list of domains.
 */
export const Validator = {
    name: "reside-domain",
    errorMessage: `Domain "${RESIDE_DOMAIN}" is already included.`,
    validate: (value) => {
        const enteredDomainNames = value.split(",").map(v => v.trim());
        return !enteredDomainNames.includes(RESIDE_DOMAIN);
    },
};
